/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface CreateTextValueDto
 */
export interface CreateTextValueDto {
    /**
     * 
     * @type {string}
     * @memberof CreateTextValueDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTextValueDto
     */
    dataTypeId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTextValueDto
     */
    isRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTextValueDto
     */
    isReadonly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTextValueDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateTextValueDto
     */
    value?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTextValueDto
     */
    $type?: CreateTextValueDtoTypeEnum;
}


/**
 * @export
 */
export const CreateTextValueDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoSystemSetupParametersCreateTextValueDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreateTextValueDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateTextValueDtoTypeEnum = typeof CreateTextValueDtoTypeEnum[keyof typeof CreateTextValueDtoTypeEnum];


/**
 * Check if a given object implements the CreateTextValueDto interface.
 */
export function instanceOfCreateTextValueDto(value?: unknown): value is CreateTextValueDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateTextValueDtoTypeEnum)[0];
}

export function CreateTextValueDtoFromJSON(json: any): CreateTextValueDto {
    return CreateTextValueDtoFromJSONTyped(json, false);
}

export function CreateTextValueDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTextValueDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dataTypeId': !exists(json, 'dataTypeId') ? undefined : json['dataTypeId'],
        'isRequired': !exists(json, 'isRequired') ? undefined : json['isRequired'],
        'isReadonly': !exists(json, 'isReadonly') ? undefined : json['isReadonly'],
        'isEnabled': !exists(json, 'isEnabled') ? undefined : json['isEnabled'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function CreateTextValueDtoToJSON(value?: CreateTextValueDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'dataTypeId': value.dataTypeId,
        'isRequired': value.isRequired,
        'isReadonly': value.isReadonly,
        'isEnabled': value.isEnabled,
        'value': value.value,
        '$type': value.$type,
    });
}

